import { login } from '@/api/mutations/auth/request';
import type { LoginPayload } from '@/api/mutations/auth/payload';
import { getAuthToken } from '@/lib/auth/auth-token';
import { normalizeEmail } from '@/lib/helpers/normalize-email';

/** Logs in after registration when the signup response did not include a token. */
export async function signInAfterAccountCreation(
  credentials: Pick<LoginPayload, 'email' | 'password' | 'isGoogleSignup'>
): Promise<void> {
  if (getAuthToken() || !credentials.password?.trim()) return;

  await login({
    email: normalizeEmail(credentials.email),
    password: credentials.password,
    isGoogleSignup: credentials.isGoogleSignup,
  });
}
